/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, createElem, getBooleanTypeAttr, getNumTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml, siblings } from '../../dom-utils';
import { moreThanOneNode } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var AUTOPLAYSPEED = 2000;
var DURATION = 520;
var Carousel = /** @class */ (function () {
    function Carousel() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-carousel', { all: true });
        this._create(this.COMPONENTS);
    }
    Carousel.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'carousel');
        var _attrs = Carousel.prototype._attrs;
        var _a = _attrs(target), autoplay = _a.autoplay, autoplaySpeed = _a.autoplaySpeed, hoverPause = _a.hoverPause;
        return {
            events: function (_a) {
                var onClick = _a.onClick, onChange = _a.onChange;
                var elems = target.querySelectorAll("." + PREFIX.carousel + "-item");
                var LeftArrow = target.querySelector("." + PREFIX.carousel + "-arrow.left");
                var RightArrow = target.querySelector("." + PREFIX.carousel + "-arrow.right");
                var lastIndex = elems.length - 1;
                var handleChange = function (siblingType, newSetElem) {
                    var oldActiveElem = target.querySelector("." + PREFIX.carousel + "-item.active");
                    var activeElem = oldActiveElem[siblingType] || newSetElem;
                    var oldValue = Number(oldActiveElem.dataset['index']);
                    // @ts-ignore
                    var value = Number(activeElem.dataset['index']);
                    onChange && type.isFn(onChange, [oldValue, value]);
                };
                var autoPlayUseChangeEvent = function () {
                    if (!autoplay)
                        return;
                    var eventTimer = null;
                    var startEvent = function () {
                        eventTimer = window.setInterval(function () {
                            handleChange('nextElementSibling', elems[0]);
                        }, autoplaySpeed);
                    };
                    var pauseEvent = function () {
                        return eventTimer ? window.clearInterval(eventTimer) : false;
                    };
                    startEvent();
                    if (hoverPause === 'false')
                        return;
                    bind(target, 'mouseenter', function () { return pauseEvent(); });
                    bind(target, 'mouseleave', function () { return startEvent(); });
                };
                var handleClick = function () {
                    elems.forEach(function (elem, index) {
                        bind(elem, 'click', function () { return onClick && type.isFn(onClick, index); });
                    });
                };
                bind(LeftArrow, 'click', function () {
                    return handleChange('previousElementSibling', elems[lastIndex]);
                });
                bind(RightArrow, 'click', function () { return handleChange('nextElementSibling', elems[0]); });
                handleClick();
                autoPlayUseChangeEvent();
            }
        };
    };
    Carousel.prototype._create = function (components) {
        var _this = this;
        components.forEach(function (node) {
            if (moreThanOneNode(node))
                return;
            var placeholderNode = node.firstElementChild;
            if (!placeholderNode)
                return;
            var carouselItemCount = placeholderNode.childElementCount;
            var _a = _this._attrs(node), dots = _a.dots, arrow = _a.arrow, effect = _a.effect, easing = _a.easing, radiusDot = _a.radiusDot, trigger = _a.trigger, autoplay = _a.autoplay, hoverPause = _a.hoverPause, autoplaySpeed = _a.autoplaySpeed;
            _this._setMainTemplate(node, dots, arrow);
            _this._setFadeCls(node, effect);
            _this._setItem(node, placeholderNode, carouselItemCount, easing);
            _this._setIndicators(node, carouselItemCount, radiusDot, trigger);
            _this._autoPlay(autoplay, node, hoverPause, autoplaySpeed);
            _this._handleArrowClick(node, arrow);
            removeAttrs(node, [
                'dots',
                'arrow',
                'effect',
                'easing',
                'trigger',
                'radius-dot',
                'autoplay',
                'hover-pause',
                'autoplay-speed'
            ]);
        });
    };
    Carousel.prototype._setMainTemplate = function (node, dots, arrow) {
        var template = "\n        <button type=\"button\" class=\"left " + PREFIX.carousel + "-arrow " + PREFIX.carousel + "-arrow-" + arrow + "\">\n           <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-arrow-back\"></i>\n        </button>\n        <div class=\"" + PREFIX.carousel + "-list\"></div>\n        <button type=\"button\" class=\"right " + PREFIX.carousel + "-arrow " + PREFIX.carousel + "-arrow-" + arrow + "\">\n           <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-arrow-forward\"></i>\n        </button>\n        <ul class=\"" + PREFIX.carousel + "-dots " + PREFIX.carousel + "-dots-" + dots + "\"></ul>\n        ";
        setHtml(node, template);
    };
    Carousel.prototype._setFadeCls = function (node, effect) {
        effect === 'fade' ? node.classList.add(PREFIX.carousel + "-" + effect) : '';
    };
    Carousel.prototype._setItem = function (node, placeholderNode, carouselItemCount, esaing) {
        var _a;
        var CarouselList = node.querySelector("." + PREFIX.carousel + "-list");
        var Fragment = document.createDocumentFragment();
        var children = Array.from(placeholderNode.children);
        var i = 0;
        for (; i < carouselItemCount; i++) {
            var CarouselItem = createElem('div');
            CarouselItem.dataset['index'] = "" + i;
            CarouselItem.className = PREFIX.carousel + "-item";
            CarouselItem.appendChild(children[i]);
            this._setEasing(CarouselItem, esaing);
            Fragment.appendChild(CarouselItem);
            (_a = Fragment.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        }
        CarouselList === null || CarouselList === void 0 ? void 0 : CarouselList.appendChild(Fragment);
    };
    Carousel.prototype._setEasing = function (item, easing) {
        if (!easing)
            return;
        setCss(item, 'transitionTimingFunction', easing);
    };
    Carousel.prototype._setIndicators = function (node, carouselItemCount, radiusDot, trigger) {
        var _a;
        var CarouselDots = node.querySelector("." + PREFIX.carousel + "-dots");
        var Fragment = document.createDocumentFragment();
        var i = 0;
        for (; i < carouselItemCount; i++) {
            var CarouselDot = createElem('li');
            CarouselDot.dataset['slideTo'] = "" + i;
            setHtml(CarouselDot, "<button type=\"button\" class=" + (radiusDot ? 'radius' : '') + "></button>");
            this._handleDotChange(trigger, node, CarouselDot);
            Fragment.appendChild(CarouselDot);
            (_a = Fragment.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList.add(PREFIX.carousel + "-active");
        }
        CarouselDots === null || CarouselDots === void 0 ? void 0 : CarouselDots.appendChild(Fragment);
    };
    Carousel.prototype._autoPlay = function (autoplay, node, hoverPause, autoplaySpeed) {
        var _this = this;
        if (!autoplay)
            return;
        var autoPlayTimer = null;
        var play = function () {
            var speed = autoplaySpeed;
            // 当轮播图自动播放的切换速度低于 650ms 会出现问题，
            // 因此低于这个数值的都会被重置为 650ms。
            if (speed < 650) {
                speed = 650;
                console.warn("[Rabbit warn] Please do not set the sliding speed of carousel to less than 650ms. There are known problems with doing so, so it has been reset to 650ms. --> " + autoplaySpeed + "ms");
            }
            autoPlayTimer = window.setInterval(function () { return _this._slide('next', node); }, speed);
        };
        play();
        if (hoverPause === 'false')
            return;
        var pause = function () { return (autoPlayTimer ? window.clearInterval(autoPlayTimer) : false); };
        bind(node, 'mouseenter', function () { return pause(); });
        bind(node, 'mouseleave', function () { return play(); });
    };
    Carousel.prototype._handleArrowClick = function (node, arrow) {
        var _this = this;
        if (arrow === 'none')
            return;
        var LeftArrow = node.querySelector("." + PREFIX.carousel + "-arrow.left");
        var RightArrow = node.querySelector("." + PREFIX.carousel + "-arrow.right");
        bind(LeftArrow, 'click', function () { return _this._slide('prev', node); });
        bind(RightArrow, 'click', function () { return _this._slide('next', node); });
    };
    Carousel.prototype._handleDotChange = function (trigger, node, dot) {
        var _this = this;
        var activeIndex, activeElem;
        var _C = function () {
            activeIndex = Number(dot.dataset['slideTo']);
            activeElem = node.querySelector("." + PREFIX.carousel + "-item[data-index=\"" + activeIndex + "\"]");
            if (activeElem.classList.contains('active'))
                return;
            _this._dotChange(node, activeIndex);
            _this._showActiveItem(activeElem);
            siblings(activeElem).forEach(function (otherElem) {
                return otherElem.classList.contains('active') ? _this._hideOldActiveItem(otherElem) : '';
            });
        };
        if (trigger === 'hover') {
            bind(dot, 'mouseenter', function () { return _C(); });
        }
        else {
            bind(dot, 'click', function () { return _C(); });
        }
    };
    Carousel.prototype._slide = function (type, node) {
        var _this = this;
        var direction = type === 'prev' ? 'right' : 'left';
        var CarouselList = node.querySelector("." + PREFIX.carousel + "-list");
        var firstIndex = 0;
        var lastIndex = CarouselList.childElementCount - 1;
        var ActiveItem = node.querySelector("." + PREFIX.carousel + "-item.active");
        var PrevItem = ActiveItem.previousElementSibling || CarouselList.children[lastIndex];
        var NextItem = ActiveItem.nextElementSibling || CarouselList.children[firstIndex];
        var __change = function (elem) { return _this._change(type, direction, node, ActiveItem, elem); };
        type === 'prev' ? __change(PrevItem) : __change(NextItem);
    };
    Carousel.prototype._change = function (type, direction, node, oldActiveItem, curActiveItem) {
        // @ts-ignore
        var activeIndex = Number(curActiveItem.dataset['index']);
        this._dotChange(node, activeIndex);
        this._showActiveItem(curActiveItem, type, direction);
        this._hideOldActiveItem(oldActiveItem, direction);
    };
    Carousel.prototype._dotChange = function (node, activeIndex) {
        var CarouselDots = node.querySelector("." + PREFIX.carousel + "-dots");
        var ActiveDot = CarouselDots.children[activeIndex];
        ActiveDot.classList.add(PREFIX.carousel + "-active");
        siblings(ActiveDot).forEach(function (dot) {
            return dot.classList.contains(PREFIX.carousel + "-active")
                ? dot.classList.remove(PREFIX.carousel + "-active")
                : '';
        });
    };
    Carousel.prototype._showActiveItem = function (activeElem, type, direction) {
        if (type === void 0) { type = 'next'; }
        if (direction === void 0) { direction = 'left'; }
        activeElem.classList.add(PREFIX.carousel + "-item-" + type);
        setTimeout(function () { return activeElem.classList.add(PREFIX.carousel + "-item-" + direction); }, 20);
        setTimeout(function () {
            activeElem.classList.add('active');
            activeElem.classList.remove(PREFIX.carousel + "-item-" + type);
            activeElem.classList.remove(PREFIX.carousel + "-item-" + direction);
        }, DURATION);
    };
    Carousel.prototype._hideOldActiveItem = function (oldElem, direction) {
        if (direction === void 0) { direction = 'left'; }
        setTimeout(function () { return oldElem.classList.add(PREFIX.carousel + "-item-" + direction); }, 20);
        setTimeout(function () {
            oldElem.classList.remove('active');
            oldElem.classList.remove(PREFIX.carousel + "-item-" + direction);
        }, DURATION);
    };
    Carousel.prototype._attrs = function (node) {
        return {
            dots: getStrTypeAttr(node, 'dots', 'inside'),
            arrow: getStrTypeAttr(node, 'arrow', 'hover'),
            effect: getStrTypeAttr(node, 'effect', ''),
            easing: getStrTypeAttr(node, 'easing', ''),
            trigger: getStrTypeAttr(node, 'trigger', 'click'),
            hoverPause: getStrTypeAttr(node, 'hover-pause', 'true'),
            radiusDot: getBooleanTypeAttr(node, 'radius-dot'),
            autoplay: getBooleanTypeAttr(node, 'autoplay'),
            autoplaySpeed: getNumTypeAttr(node, 'autoplay-speed', AUTOPLAYSPEED)
        };
    };
    return Carousel;
}());
export default Carousel;
